import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const SexToNutrition = {
  label: "性別 vs 營養管理",
  key: "SexToNutrition",
  path: "BMI/SexToNutrition",
  api: "TCS_V_BMIHENutritionV",
  render: (options) => <Diagram.BMI.SexToNutrition {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "性別",
      field: "性別",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
